import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            height: "100%",
        },
        content: {
            padding: theme.spacing(3),
        },
    })
);
